<template>
  <div class="flag-group">
    <figure v-for="(country, index) in filteredCountries" :key="index">
      <CountryIcon :country="country" />
    </figure>
    <button v-if="viewButton" class="flag-group__view" @click="viewAll">
      View all
    </button>
    <p
      v-else-if="countries.length - filteredCountries.length"
      class="link-all-flag"
    >
      +{{ countries.length - filteredCountries.length }}
    </p>
    <!--    <p v-else-if="countries.length === 1" class="link-all-flag">only</p>-->
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef, defineProps, PropType } from "vue";
import { Country } from "@/stores/data";
import { useAppStore } from "@/stores/app";
import PopupCountries from "@/components/popups/PopupCountries.vue";
import CountryIcon from "@/components/icons/CountryIcon.vue";

const props = defineProps({
  countries: {
    type: Array as PropType<Array<Country>>,
    required: true,
    default: () => [],
  },
  requestedCountries: {
    type: Array as PropType<Array<Country>>,
    required: true,
    default: () => [],
  },
  showMaxCountriesLength: { type: Number },
  viewButton: {
    type: Boolean,
    default: false,
  },
});

const appStore = useAppStore();

const filteredCountries: ComputedRef<Country[]> = computed(() => {
  if (props.showMaxCountriesLength) {
    const countries: Country[] = [];

    props.requestedCountries.forEach((c) => {
      countries.push(c);
    });

    props.countries.forEach((c) => {
      const countryExist = countries.find((country) => country.id === c.id);
      if (!countryExist) countries.push(c);
    });

    return countries.splice(0, props.showMaxCountriesLength);
  }

  const countries: Country[] = [
    ...(props.requestedCountries?.length ? props.requestedCountries : []),
  ];

  return countries.splice(0, 2);
});

function viewAll(): void {
  appStore.showPopup({
    component: PopupCountries,
    props: {
      countries: props.countries,
      requestedCountries: props.requestedCountries,
    },
  });
}
</script>

<style scoped></style>
